import http from '@/utils/http';
const base_path = '/v2/tool/keywordRecommend';

/**
 * 获取关键词推荐结果接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getKeywordListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
